import styled from 'styled-components';

export const Container = styled.div`
  width: 90%;
  border-radius: 20px;
  background: #f4f4f4;
  position: absolute;
  z-index: 999;
  left: 50%;
  transform: translateX(-50%);
  top: 50vh;

  p {
    font-family: Roboto;
    margin: 0;
  }
`;

export const Overlay = styled.div`
  position: fixed;
  background-color: rgba(0, 0, 0, 0.3);
  height: 100%;
  width: 100%;
  z-index: 999;
`;

export const HeadingBox = styled.div`
  display: flex;
  gap: 16.39px;
  align-items: center;
  padding: 24px 0px 22.5px 24px;
  border-bottom: 1.8px solid rgba(200, 200, 200, 0.4);

  p {
    color: #202124;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 100%;
  }
`;

export const LogoBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 7.67px;
  border-radius: 10.733px;
  background: rgba(255, 255, 255, 0.6);
  box-shadow: 0px 3.067px 12.267px 0px rgba(0, 0, 0, 0.04);
`;

export const Main = styled.div`
  padding: 18px 24px 50px;
  position: relative;

  p {
    color: #202124;
    font-size: 1rem;
    font-style: normal;
    font-weight: 400;
    line-height: 120%;
  }
`;

export const ListBox = styled.div`
  margin-top: 28px;
  display: flex;
  flex-direction: column;
  gap: 19px;

  div {
    display: flex;
    gap: 9.5px;
    align-items: center;
  }
`;

export const CloseBox = styled.div`
  position: absolute;
  background: #fff;
  border-radius: 50%;
  right: 10px;
  bottom: 12.4px;
  padding: 11.4px;
  box-shadow: 0px 0px 13px 0px rgba(0, 0, 0, 0.04);
`;

export const DownloadIconBox = styled.div`
  background: #fff;
  box-shadow: 0px 0px 9.103px 0px rgba(0, 0, 0, 0.04);
  padding: 3.4px 5.9px;

  img {
    width: 100%;
    height: 100%;
  }
`;

export const AddtoHomeBox = styled.div`
  padding: 7.28px;
  background-color: #fff;

  p {
    color: #000;
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: 100%;
  }
`;
